<template>
  <div >
       <slot></slot>
       <div>
           23
       </div>
  </div>
</template>
<script>
  export default {
    name: 'CWFormItem',

    componentName: 'CWFormItem',

    props: {      
      rules: [Object, Array],
      error: String,      
      showMessage: {
        type: Boolean,
        default: true
      }
    },
    components: {     
    },
    watch: {
      error: {
        immediate: true,
        handler(value) {         
        }
      }
    },
    data() {
      return {
      };
    },
    methods: {
      
    }
    
  };
</script>
